import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './AccessDeniedView.sass'
import { EmptyState, EmptyStateIllustrationImage } from 'components/EmptyState'
import { useBrandingSettings } from 'hooks/branding'

interface Props {
  title?: string
  description?: React.ReactNode
  ['data-test']?: string
}

export default observer(function AccessDenied({
  title = 'Access Denied',
  description = 'You are not allowed to view this page. If you believe this is an error, please contact your Workspace administrator.',
  'data-test': dataTest,
}: Props) {
  const { corporateMode } = useBrandingSettings()

  return (
    <div className={cx(styles.root)} data-test={dataTest}>
      <div className={styles.box}>
        <EmptyState
          animate
          pad
          title={title}
          subtitle={description}
          hideIllustration={corporateMode}
          image={
            <EmptyStateIllustrationImage
              src={require('assets/images/img_chat-disabled.svg')}
            />
          }
        />
      </div>
    </div>
  )
})
